// extracted by mini-css-extract-plugin
var _1 = "lHuQmndtHw7l1T36vYtT";
var _2 = "dRdjWiAS8BH3hQ45NsA9";
export { _1 as "newsletter", _2 as "submit" }
